import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'environments/environment';

import { UserRole } from '@shared/models';
import { DeviceInfoService } from '@shared/services';
import { TokenService } from '@shared/services/token.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const tokenService = this.injector.get(TokenService);
    const deviceInfoService = this.injector.get(DeviceInfoService);
    request = request.clone({ headers: addAuthHeaders(request.url, request.headers, tokenService, deviceInfoService) });

    // get token from response
    const responseToken = request.headers.get('X-Access-Token');
    if (responseToken && responseToken != null && responseToken !== '') {
      tokenService.setToken(responseToken);
    }

    return next.handle(request);
  }
}

export function addAuthHeaders<THeaders extends AuthHeaders>(
  requestUrl: string,
  headers: THeaders,
  tokenService: TokenService,
  deviceInfoService: DeviceInfoService
): THeaders {
  const token = tokenService.token;
  const companyId = tokenService.user?.companyId;
  const deviceUid = deviceInfoService.getDeviceUuid();

  if (token && requestUrl.includes(environment.baseUrl)) {
    headers = setHeader(headers, 'Authorization', `Bearer ${token}`);
  }

  if (deviceUid) {
    headers = setHeader(headers, 'DeviceUid', deviceUid);
  }

  if (companyId && tokenService.isUserInOneOfRoles([UserRole.Admin, UserRole.Agent])) {
    headers = setHeader(headers, 'CompanyId', companyId);
  }

  if (!headers.has('Accept')) {
    headers = setHeader(headers, 'Accept', 'application/json');
  }

  return headers;
}

type AuthHeaders = {
  has(name: string): boolean;
  set(name: string, value: string): AuthHeaders | void;
};

function setHeader<THeaders extends AuthHeaders>(headers: THeaders, name: string, value: string): THeaders {
  const updatedHeaders = headers.set(name, value) as THeaders | void;
  return updatedHeaders ? updatedHeaders : headers;
}
